
  import {Component, Vue} from 'vue-property-decorator';
  import {userApi} from "@/api/organization";
  @Component
  export default class Home extends Vue {
    title = "第一页负责跳转";
    created() {
      const version = "1.0.0";
      const versionL = localStorage.getItem("version");
      if(!versionL || versionL != version){
        localStorage.clear();
        localStorage.setItem("version",version)
      }
      this.autologin();
    }
    //不可自动登录则通过接口验证登录状态
    checkLogin(){
      userApi.getUserConfig("aaaa").then(e=>{
        if(e.data.result === 0){
          this.$router.push("/list")
        }
      })
    }
    //自动登录验证
    autologin(){
      if(this.$store.state.AuthedUser){
        const appId = this.$route.query.appId as string;
        const returnUrl = this.$route.query.returnUrl as string;
        if(appId && returnUrl){
          this.getCode(appId,returnUrl);
        }else{
          this.checkLogin();
        }
      }else{
        this.checkLogin();
      }
    }
    getCode(appId: string,returnUrl: string){
      userApi.obtainCode({appId: appId}).then(r => {
        if(r.data.result == 0){
          const code = r.data.data;
          window.location.href = (returnUrl + (returnUrl.includes("?") ? '&code=' : '?code=')+ code);
        }
      })
    }
  }
